/* eslint-disable */
	// Do not edit this file, it is auto-generated at build time!
	// See scripts/jss/generate-component-factory.js to modify the generation of this file.
	import React, { Suspense } from 'react';
const UnauthoredComponent = React.lazy(() => import(/* webpackChunkName: "UnauthoredComponent" */ '../../jss-components/sitecore/UnauthoredComponent'));

const Breadcrumbs = React.lazy(() => import(/* webpackChunkName: "Breadcrumbs" */ '../../jss-components/t01-navigation/Breadcrumbs/index.ts'));

const Footer = React.lazy(() => import(/* webpackChunkName: "Footer" */ '../../jss-components/t01-navigation/Footer/index.ts'));

const Header = React.lazy(() => import(/* webpackChunkName: "Header" */ '../../jss-components/t01-navigation/Header/index.ts'));

const Dashboard = React.lazy(() => import(/* webpackChunkName: "Dashboard" */ '../../jss-components/t02-layout/e01-templates/Dashboard/index.ts'));

const GeneralOneColumn = React.lazy(() => import(/* webpackChunkName: "GeneralOneColumn" */ '../../jss-components/t02-layout/e01-templates/GeneralOneColumn/index.ts'));

const GeneralTwoColumnLeft = React.lazy(() => import(/* webpackChunkName: "GeneralTwoColumnLeft" */ '../../jss-components/t02-layout/e01-templates/GeneralTwoColumnLeft/index.ts'));

const GeneralTwoColumnRight = React.lazy(() => import(/* webpackChunkName: "GeneralTwoColumnRight" */ '../../jss-components/t02-layout/e01-templates/GeneralTwoColumnRight/index.ts'));

const UnauthenticatedOneColumn = React.lazy(() => import(/* webpackChunkName: "UnauthenticatedOneColumn" */ '../../jss-components/t02-layout/e01-templates/UnauthenticatedOneColumn/index.ts'));

const Accordion = React.lazy(() => import(/* webpackChunkName: "Accordion" */ '../../jss-components/t02-layout/e02-modules/Accordion/index.ts'));

const CallToActionCard = React.lazy(() => import(/* webpackChunkName: "CallToActionCard" */ '../../jss-components/t02-layout/e02-modules/CallToActionCard/index.ts'));

const ContentBlock = React.lazy(() => import(/* webpackChunkName: "ContentBlock" */ '../../jss-components/t02-layout/e02-modules/ContentBlock/index.ts'));

const DownloadsBlock = React.lazy(() => import(/* webpackChunkName: "DownloadsBlock" */ '../../jss-components/t02-layout/e02-modules/DownloadsBlock/index.ts'));

const HeroModule = React.lazy(() => import(/* webpackChunkName: "HeroModule" */ '../../jss-components/t02-layout/e02-modules/HeroModule/index.ts'));

const IconTile = React.lazy(() => import(/* webpackChunkName: "IconTile" */ '../../jss-components/t02-layout/e02-modules/IconTile/index.ts'));

const ImageBlock = React.lazy(() => import(/* webpackChunkName: "ImageBlock" */ '../../jss-components/t02-layout/e02-modules/ImageBlock/index.ts'));

const LinksBlock = React.lazy(() => import(/* webpackChunkName: "LinksBlock" */ '../../jss-components/t02-layout/e02-modules/LinksBlock/index.ts'));

const MemberDetailsForm = React.lazy(() => import(/* webpackChunkName: "MemberDetailsForm" */ '../../jss-components/t02-layout/e02-modules/MemberDetailsForm/index.ts'));

const MemberPreferencesLink = React.lazy(() => import(/* webpackChunkName: "MemberPreferencesLink" */ '../../jss-components/t02-layout/e02-modules/MemberPreferencesLink/index.ts'));

const PageLevelNotification = React.lazy(() => import(/* webpackChunkName: "PageLevelNotification" */ '../../jss-components/t02-layout/e02-modules/PageLevelNotification/index.ts'));

const QuickActionsList = React.lazy(() => import(/* webpackChunkName: "QuickActionsList" */ '../../jss-components/t02-layout/e02-modules/QuickActionsList/index.ts'));

const QuickActionsTile = React.lazy(() => import(/* webpackChunkName: "QuickActionsTile" */ '../../jss-components/t02-layout/e02-modules/QuickActionsTile/index.ts'));

const RichText = React.lazy(() => import(/* webpackChunkName: "RichText" */ '../../jss-components/t02-layout/e02-modules/RichText/index.ts'));

const Tabs = React.lazy(() => import(/* webpackChunkName: "Tabs" */ '../../jss-components/t02-layout/e02-modules/Tabs/index.ts'));

const VideoBlock = React.lazy(() => import(/* webpackChunkName: "VideoBlock" */ '../../jss-components/t02-layout/e02-modules/VideoBlock/index.ts'));

const FiftyFiftySubLayout = React.lazy(() => import(/* webpackChunkName: "FiftyFiftySubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/FiftyFiftySubLayout/index.ts'));

const FullWidthSubLayout = React.lazy(() => import(/* webpackChunkName: "FullWidthSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/FullWidthSubLayout/index.ts'));

const OneThirdTwoThirdsSubLayout = React.lazy(() => import(/* webpackChunkName: "OneThirdTwoThirdsSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/OneThirdTwoThirdsSubLayout/index.ts'));

const QuartersSubLayout = React.lazy(() => import(/* webpackChunkName: "QuartersSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/QuartersSubLayout/index.ts'));

const ThirdsSubLayout = React.lazy(() => import(/* webpackChunkName: "ThirdsSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/ThirdsSubLayout/index.ts'));

const TwoThirdsOneThirdSubLayout = React.lazy(() => import(/* webpackChunkName: "TwoThirdsOneThirdSubLayout" */ '../../jss-components/t02-layout/e03-subLayouts/generated/TwoThirdsOneThirdSubLayout/index.ts'));

const GreenId = React.lazy(() => import(/* webpackChunkName: "GreenId" */ '../../jss-components/t04-security/GreenId/index.ts'));

const IDVForm = React.lazy(() => import(/* webpackChunkName: "IDVForm" */ '../../jss-components/t04-security/IDVForm/index.ts'));

const OneTimePasscode = React.lazy(() => import(/* webpackChunkName: "OneTimePasscode" */ '../../jss-components/t04-security/OneTimePasscode/index.ts'));

const VerifyYourIdentity = React.lazy(() => import(/* webpackChunkName: "VerifyYourIdentity" */ '../../jss-components/t04-security/VerifyYourIdentity/index.ts'));

const DbAccountSnapshot = React.lazy(() => import(/* webpackChunkName: "DbAccountSnapshot" */ '../../jss-components/t06-dashboard/DbAccountSnapshot/index.ts'));

const DbAccountSnapshotResilience = React.lazy(() => import(/* webpackChunkName: "DbAccountSnapshotResilience" */ '../../jss-components/t06-dashboard/DbAccountSnapshotResilience/index.ts'));

const DbAnnualStatements = React.lazy(() => import(/* webpackChunkName: "DbAnnualStatements" */ '../../jss-components/t06-dashboard/DbAnnualStatements/index.ts'));

const DbBPAY = React.lazy(() => import(/* webpackChunkName: "DbBPAY" */ '../../jss-components/t06-dashboard/DbBPAY/index.ts'));

const DbBeneficiaries = React.lazy(() => import(/* webpackChunkName: "DbBeneficiaries" */ '../../jss-components/t06-dashboard/DbBeneficiaries/index.ts'));

const DbFinancialAdviserModule = React.lazy(() => import(/* webpackChunkName: "DbFinancialAdviserModule" */ '../../jss-components/t06-dashboard/DbFinancialAdviserModule/index.ts'));

const DbHeroBanner = React.lazy(() => import(/* webpackChunkName: "DbHeroBanner" */ '../../jss-components/t06-dashboard/DbHeroBanner/index.ts'));

const DbImportantNotice = React.lazy(() => import(/* webpackChunkName: "DbImportantNotice" */ '../../jss-components/t06-dashboard/DbImportantNotice/index.ts'));

const DbInsuranceCover = React.lazy(() => import(/* webpackChunkName: "DbInsuranceCover" */ '../../jss-components/t06-dashboard/DbInsuranceCover/index.ts'));

const DbInsuranceCoverResilience = React.lazy(() => import(/* webpackChunkName: "DbInsuranceCoverResilience" */ '../../jss-components/t06-dashboard/DbInsuranceCoverResilience/index.ts'));

const DbInvestments = React.lazy(() => import(/* webpackChunkName: "DbInvestments" */ '../../jss-components/t06-dashboard/DbInvestments/index.ts'));

const DbInvestmentsResilience = React.lazy(() => import(/* webpackChunkName: "DbInvestmentsResilience" */ '../../jss-components/t06-dashboard/DbInvestmentsResilience/index.ts'));

const DbLatestContributionModule = React.lazy(() => import(/* webpackChunkName: "DbLatestContributionModule" */ '../../jss-components/t06-dashboard/DbLatestContributionModule/index.ts'));

const DbNextBestActionsModule = React.lazy(() => import(/* webpackChunkName: "DbNextBestActionsModule" */ '../../jss-components/t06-dashboard/DbNextBestActionsModule/index.ts'));

const DbNoiInformationBanner = React.lazy(() => import(/* webpackChunkName: "DbNoiInformationBanner" */ '../../jss-components/t06-dashboard/DbNoiInformationBanner/index.ts'));

const DbOutageModal = React.lazy(() => import(/* webpackChunkName: "DbOutageModal" */ '../../jss-components/t06-dashboard/DbOutageModal/index.ts'));

const DbPaymentInformation = React.lazy(() => import(/* webpackChunkName: "DbPaymentInformation" */ '../../jss-components/t06-dashboard/DbPaymentInformation/index.ts'));

const DbProfileSetupActions = React.lazy(() => import(/* webpackChunkName: "DbProfileSetupActions" */ '../../jss-components/t06-dashboard/DbProfileSetupActions/index.ts'));

const DbSectionHeading = React.lazy(() => import(/* webpackChunkName: "DbSectionHeading" */ '../../jss-components/t06-dashboard/DbSectionHeading/index.ts'));

const DbSkeletonLoader = React.lazy(() => import(/* webpackChunkName: "DbSkeletonLoader" */ '../../jss-components/t06-dashboard/DbSkeletonLoader/index.ts'));

const DbVideoBlock = React.lazy(() => import(/* webpackChunkName: "DbVideoBlock" */ '../../jss-components/t06-dashboard/DbVideoBlock/index.ts'));

const Widget = React.lazy(() => import(/* webpackChunkName: "Widget" */ '../../jss-components/t06-dashboard/subcomponents/Widget/index.ts'));

const AccountLockedScreen = React.lazy(() => import(/* webpackChunkName: "AccountLockedScreen" */ '../../jss-components/t07-account-access/AccountLockedScreen/index.ts'));

const ContentNotAvailable = React.lazy(() => import(/* webpackChunkName: "ContentNotAvailable" */ '../../jss-components/t07-account-access/ContentNotAvailable/index.ts'));

const DeviceCheck = React.lazy(() => import(/* webpackChunkName: "DeviceCheck" */ '../../jss-components/t07-account-access/DeviceCheck/index.ts'));

const DisplayLogoutSuccess = React.lazy(() => import(/* webpackChunkName: "DisplayLogoutSuccess" */ '../../jss-components/t07-account-access/DisplayLogoutSuccess/index.ts'));

const EditUsernameAndPassword = React.lazy(() => import(/* webpackChunkName: "EditUsernameAndPassword" */ '../../jss-components/t07-account-access/EditUsernameAndPassword/index.ts'));

const GuidedTour = React.lazy(() => import(/* webpackChunkName: "GuidedTour" */ '../../jss-components/t07-account-access/GuidedTour/index.ts'));

const IdentityVerification = React.lazy(() => import(/* webpackChunkName: "IdentityVerification" */ '../../jss-components/t07-account-access/IdentityVerification/index.ts'));

const LastLogin = React.lazy(() => import(/* webpackChunkName: "LastLogin" */ '../../jss-components/t07-account-access/LastLogin/index.ts'));

const LastLoginMobileView = React.lazy(() => import(/* webpackChunkName: "LastLoginMobileView" */ '../../jss-components/t07-account-access/LastLoginMobileView/index.ts'));

const Login = React.lazy(() => import(/* webpackChunkName: "Login" */ '../../jss-components/t07-account-access/Login/index.ts'));

const LoginSettings = React.lazy(() => import(/* webpackChunkName: "LoginSettings" */ '../../jss-components/t07-account-access/LoginSettings/index.ts'));

const MPRegistrationForm = React.lazy(() => import(/* webpackChunkName: "MPRegistrationForm" */ '../../jss-components/t07-account-access/MPRegistrationForm/index.ts'));

const ManageTrustedDevice = React.lazy(() => import(/* webpackChunkName: "ManageTrustedDevice" */ '../../jss-components/t07-account-access/ManageTrustedDevice/index.ts'));

const OnboardingJourney = React.lazy(() => import(/* webpackChunkName: "OnboardingJourney" */ '../../jss-components/t07-account-access/OnboardingJourney/index.ts'));

const OutageBannerNotification = React.lazy(() => import(/* webpackChunkName: "OutageBannerNotification" */ '../../jss-components/t07-account-access/OutageBannerNotification/index.ts'));

const RecoverUsername = React.lazy(() => import(/* webpackChunkName: "RecoverUsername" */ '../../jss-components/t07-account-access/RecoverUsername/index.ts'));

const ResetPassword = React.lazy(() => import(/* webpackChunkName: "ResetPassword" */ '../../jss-components/t07-account-access/ResetPassword/index.ts'));

const ResilienceMaintenance = React.lazy(() => import(/* webpackChunkName: "ResilienceMaintenance" */ '../../jss-components/t07-account-access/ResilienceMaintenance/index.ts'));

const SecurityTip = React.lazy(() => import(/* webpackChunkName: "SecurityTip" */ '../../jss-components/t07-account-access/SecurityTip/index.ts'));

const WelcomeBanner = React.lazy(() => import(/* webpackChunkName: "WelcomeBanner" */ '../../jss-components/t07-account-access/WelcomeBanner/index.ts'));

const WelcomeDashboardModule = React.lazy(() => import(/* webpackChunkName: "WelcomeDashboardModule" */ '../../jss-components/t07-account-access/WelcomeDashboardModule/index.ts'));

const PendingProfileAccountDetailsModule = React.lazy(() => import(/* webpackChunkName: "PendingProfileAccountDetailsModule" */ '../../jss-components/t08-activate-account/PendingProfileAccountDetailsModule/index.ts'));

const PendingProfileActionsModule = React.lazy(() => import(/* webpackChunkName: "PendingProfileActionsModule" */ '../../jss-components/t08-activate-account/PendingProfileActionsModule/index.ts'));

const AccountSwitcher = React.lazy(() => import(/* webpackChunkName: "AccountSwitcher" */ '../../jss-components/t09-multiple-accounts/AccountSwitcher/index.ts'));

const MemberContactDetails = React.lazy(() => import(/* webpackChunkName: "MemberContactDetails" */ '../../jss-components/t10-member-details/MemberContactDetails/index.ts'));

const RestrictionNotification = React.lazy(() => import(/* webpackChunkName: "RestrictionNotification" */ '../../jss-components/t10-member-details/RestrictionNotification/index.ts'));

const AnnualStatements = React.lazy(() => import(/* webpackChunkName: "AnnualStatements" */ '../../jss-components/t11-member-documentation/AnnualStatements/index.ts'));

const SavedApplications = React.lazy(() => import(/* webpackChunkName: "SavedApplications" */ '../../jss-components/t11-member-documentation/MyApplications/SavedApplications/index.ts'));

const SubmittedApplications = React.lazy(() => import(/* webpackChunkName: "SubmittedApplications" */ '../../jss-components/t11-member-documentation/MyApplications/SubmittedApplications/index.ts'));

const SubmittedBankAccount = React.lazy(() => import(/* webpackChunkName: "SubmittedBankAccount" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedBankAccount/index.ts'));

const SubmittedDirectDebit = React.lazy(() => import(/* webpackChunkName: "SubmittedDirectDebit" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedDirectDebit/index.ts'));

const SubmittedFinancialHardship = React.lazy(() => import(/* webpackChunkName: "SubmittedFinancialHardship" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedFinancialHardship/index.ts'));

const SubmittedNoticeOfIntent = React.lazy(() => import(/* webpackChunkName: "SubmittedNoticeOfIntent" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedNoticeOfIntent/index.ts'));

const SubmittedReachedPreservationAge = React.lazy(() => import(/* webpackChunkName: "SubmittedReachedPreservationAge" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedReachedPreservationAge/index.ts'));

const SubmittedSpouseContribution = React.lazy(() => import(/* webpackChunkName: "SubmittedSpouseContribution" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedSpouseContribution/index.ts'));

const SubmittedTransferToAnotherFund = React.lazy(() => import(/* webpackChunkName: "SubmittedTransferToAnotherFund" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedTransferToAnotherFund/index.ts'));

const SubmittedUnrestrictedNonPreserved = React.lazy(() => import(/* webpackChunkName: "SubmittedUnrestrictedNonPreserved" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/SubmittedUnrestrictedNonPreserved/index.ts'));

const ViewApplicationDetails = React.lazy(() => import(/* webpackChunkName: "ViewApplicationDetails" */ '../../jss-components/t11-member-documentation/MyApplications/subComponents/viewSubmittedApplication/ViewApplicationDetails/index.ts'));

const AccountsDetailsModule = React.lazy(() => import(/* webpackChunkName: "AccountsDetailsModule" */ '../../jss-components/t11-member-documentation/e01-notify-employer/AccountsDetailsModule/index.ts'));

const NotifyYourEmployer = React.lazy(() => import(/* webpackChunkName: "NotifyYourEmployer" */ '../../jss-components/t11-member-documentation/e01-notify-employer/NotifyYourEmployer/index.ts'));

const NotifyYourEmployerConfirmation = React.lazy(() => import(/* webpackChunkName: "NotifyYourEmployerConfirmation" */ '../../jss-components/t11-member-documentation/e01-notify-employer/NotifyYourEmployerConfirmation/index.ts'));

const TransactionsSummary = React.lazy(() => import(/* webpackChunkName: "TransactionsSummary" */ '../../jss-components/t12-transactions/TransactionsSummary/index.ts'));

const ViewBalanceHistory = React.lazy(() => import(/* webpackChunkName: "ViewBalanceHistory" */ '../../jss-components/t12-transactions/ViewBalanceHistory/index.ts'));

const ViewTransactions = React.lazy(() => import(/* webpackChunkName: "ViewTransactions" */ '../../jss-components/t12-transactions/ViewTransactions/index.ts'));

const BPAY = React.lazy(() => import(/* webpackChunkName: "BPAY" */ '../../jss-components/t13-contribution/BPAY/index.ts'));

const BPAYDownsizer = React.lazy(() => import(/* webpackChunkName: "BPAYDownsizer" */ '../../jss-components/t13-contribution/BPAYDownsizer/index.ts'));

const ContributionCaps = React.lazy(() => import(/* webpackChunkName: "ContributionCaps" */ '../../jss-components/t13-contribution/ContributionCaps/index.ts'));

const DirectDebit = React.lazy(() => import(/* webpackChunkName: "DirectDebit" */ '../../jss-components/t13-contribution/DirectDebit/index.ts'));

const DirectDebitForm = React.lazy(() => import(/* webpackChunkName: "DirectDebitForm" */ '../../jss-components/t13-contribution/DirectDebitForm/index.ts'));

const SpouseContributionsConfirmation = React.lazy(() => import(/* webpackChunkName: "SpouseContributionsConfirmation" */ '../../jss-components/t13-contribution/SpouseContributionsConfirmation/index.ts'));

const SpouseContributionsForm = React.lazy(() => import(/* webpackChunkName: "SpouseContributionsForm" */ '../../jss-components/t13-contribution/SpouseContributionsForm/index.ts'));

const SpouseContributionsLandingPage = React.lazy(() => import(/* webpackChunkName: "SpouseContributionsLandingPage" */ '../../jss-components/t13-contribution/SpouseContributionsLandingPage/index.ts'));

const TotalContributions = React.lazy(() => import(/* webpackChunkName: "TotalContributions" */ '../../jss-components/t13-contribution/TotalContributions/index.ts'));

const ManageBeneficiaries = React.lazy(() => import(/* webpackChunkName: "ManageBeneficiaries" */ '../../jss-components/t14-beneficiaries/ManageBeneficiaries/index.ts'));

const ViewUpdateBeneficiaries = React.lazy(() => import(/* webpackChunkName: "ViewUpdateBeneficiaries" */ '../../jss-components/t14-beneficiaries/ViewUpdateBeneficiaries/index.ts'));

const CardList = React.lazy(() => import(/* webpackChunkName: "CardList" */ '../../jss-components/t15-combine-super/CardList/index.ts'));

const CombineSuperContext = React.lazy(() => import(/* webpackChunkName: "CombineSuperContext" */ '../../jss-components/t15-combine-super/CombineSuperContext/index.ts'));

const CombineSuperForm = React.lazy(() => import(/* webpackChunkName: "CombineSuperForm" */ '../../jss-components/t15-combine-super/CombineSuperForm/index.ts'));

const SimpleConsolidationForm = React.lazy(() => import(/* webpackChunkName: "SimpleConsolidationForm" */ '../../jss-components/t15-combine-super/SimpleConsolidationForm/index.ts'));

const BenefitQuoteResults = React.lazy(() => import(/* webpackChunkName: "BenefitQuoteResults" */ '../../jss-components/t16-benefit-quote/BenefitQuoteResults/index.ts'));

const GenerateBenefitQuote = React.lazy(() => import(/* webpackChunkName: "GenerateBenefitQuote" */ '../../jss-components/t16-benefit-quote/GenerateBenefitQuote/index.ts'));

const EditInvestmentOptions = React.lazy(() => import(/* webpackChunkName: "EditInvestmentOptions" */ '../../jss-components/t17-investments/EditInvestmentOptions/index.ts'));

const ViewInvestmentPerformance = React.lazy(() => import(/* webpackChunkName: "ViewInvestmentPerformance" */ '../../jss-components/t17-investments/ViewInvestmentPerformance/index.ts'));

const ViewInvestments = React.lazy(() => import(/* webpackChunkName: "ViewInvestments" */ '../../jss-components/t17-investments/ViewInvestments/index.ts'));

const ViewPendingInvestmentSwitch = React.lazy(() => import(/* webpackChunkName: "ViewPendingInvestmentSwitch" */ '../../jss-components/t17-investments/ViewPendingInvestmentSwitch/index.ts'));

const CentrelinkDownloadSection = React.lazy(() => import(/* webpackChunkName: "CentrelinkDownloadSection" */ '../../jss-components/t18-income-payments/CentrelinkDownloadSection/index.ts'));

const EditPaymentAmountAndFrequency = React.lazy(() => import(/* webpackChunkName: "EditPaymentAmountAndFrequency" */ '../../jss-components/t18-income-payments/EditPaymentAmountAndFrequency/index.ts'));

const ViewBankDetails = React.lazy(() => import(/* webpackChunkName: "ViewBankDetails" */ '../../jss-components/t18-income-payments/ViewBankDetails/index.ts'));

const ViewCentrelinkSchedule = React.lazy(() => import(/* webpackChunkName: "ViewCentrelinkSchedule" */ '../../jss-components/t18-income-payments/ViewCentrelinkSchedule/index.ts'));

const ViewPaymentDetails = React.lazy(() => import(/* webpackChunkName: "ViewPaymentDetails" */ '../../jss-components/t18-income-payments/ViewPaymentDetails/index.ts'));

const ViewPaymentSummary = React.lazy(() => import(/* webpackChunkName: "ViewPaymentSummary" */ '../../jss-components/t18-income-payments/ViewPaymentSummary/index.ts'));

const FinancialHardshipA = React.lazy(() => import(/* webpackChunkName: "FinancialHardshipA" */ '../../jss-components/t19-withdrawals/FinancialHardship/FinancialHardshipA/index.ts'));

const FinancialHardshipB = React.lazy(() => import(/* webpackChunkName: "FinancialHardshipB" */ '../../jss-components/t19-withdrawals/FinancialHardship/FinancialHardshipB/index.ts'));

const Pension = React.lazy(() => import(/* webpackChunkName: "Pension" */ '../../jss-components/t19-withdrawals/Pension/index.ts'));

const ReachedPreservationAge = React.lazy(() => import(/* webpackChunkName: "ReachedPreservationAge" */ '../../jss-components/t19-withdrawals/ReachedPreservationAge/index.ts'));

const TransferToAnotherFund = React.lazy(() => import(/* webpackChunkName: "TransferToAnotherFund" */ '../../jss-components/t19-withdrawals/TransferToAnotherFund/index.ts'));

const UnrestrictedNonPreserved = React.lazy(() => import(/* webpackChunkName: "UnrestrictedNonPreserved" */ '../../jss-components/t19-withdrawals/UnrestrictedNonPreserved/index.ts'));

const WithdrawalsDownloadsBlock = React.lazy(() => import(/* webpackChunkName: "WithdrawalsDownloadsBlock" */ '../../jss-components/t19-withdrawals/WithdrawalsDownloadsBlock/index.ts'));

const WithdrawalsLandingPage = React.lazy(() => import(/* webpackChunkName: "WithdrawalsLandingPage" */ '../../jss-components/t19-withdrawals/WithdrawalsLandingPage/index.ts'));

const LoadingScreen = React.lazy(() => import(/* webpackChunkName: "LoadingScreen" */ '../../jss-components/t19-withdrawals/subcomponents/LoadingScreen/index.ts'));

const MobileRestrictionScreen = React.lazy(() => import(/* webpackChunkName: "MobileRestrictionScreen" */ '../../jss-components/t19-withdrawals/subcomponents/MobileRestrictionScreen/index.ts'));

const RenderButtons = React.lazy(() => import(/* webpackChunkName: "RenderButtons" */ '../../jss-components/t19-withdrawals/subcomponents/RenderButtons/index.ts'));

const SaveScreen = React.lazy(() => import(/* webpackChunkName: "SaveScreen" */ '../../jss-components/t19-withdrawals/subcomponents/SaveScreen/index.ts'));

const WithdrawalsErrorModal = React.lazy(() => import(/* webpackChunkName: "WithdrawalsErrorModal" */ '../../jss-components/t19-withdrawals/subcomponents/WithdrawalsErrorModal/index.ts'));

const TALRefresh = React.lazy(() => import(/* webpackChunkName: "TALRefresh" */ '../../jss-components/t20-insurance/TALRefresh/index.ts'));

const ViewInsuranceCover = React.lazy(() => import(/* webpackChunkName: "ViewInsuranceCover" */ '../../jss-components/t20-insurance/ViewInsuranceCover/index.ts'));

const ViewInsuranceCoverSummary = React.lazy(() => import(/* webpackChunkName: "ViewInsuranceCoverSummary" */ '../../jss-components/t20-insurance/ViewInsuranceCoverSummary/index.ts'));

const CommunicationPreferences = React.lazy(() => import(/* webpackChunkName: "CommunicationPreferences" */ '../../jss-components/t21-communication/CommunicationPreferences/index.ts'));

const InboxMessagesAndNotifications = React.lazy(() => import(/* webpackChunkName: "InboxMessagesAndNotifications" */ '../../jss-components/t21-communication/InboxMessagesAndNotifications/index.ts'));

const TaxFileNumber = React.lazy(() => import(/* webpackChunkName: "TaxFileNumber" */ '../../jss-components/t24-tax-file-number/TaxFileNumber/index.ts'));

const LivePerson = React.lazy(() => import(/* webpackChunkName: "LivePerson" */ '../../jss-components/t25-live-person/LivePerson/index.ts'));

const NoticeOfIntentForm = React.lazy(() => import(/* webpackChunkName: "NoticeOfIntentForm" */ '../../jss-components/t26-claim-tax-deduction/NoticeOfIntentForm/index.ts'));

const NoticeOfIntentLandingPage = React.lazy(() => import(/* webpackChunkName: "NoticeOfIntentLandingPage" */ '../../jss-components/t26-claim-tax-deduction/NoticeOfIntentLandingPage/index.ts'));

const ChangeBankDetailsForm = React.lazy(() => import(/* webpackChunkName: "ChangeBankDetailsForm" */ '../../jss-components/t27-change-bank-details/ChangeBankDetailsForm/index.ts'));

const ChangeBankDetailsLandingPage = React.lazy(() => import(/* webpackChunkName: "ChangeBankDetailsLandingPage" */ '../../jss-components/t27-change-bank-details/ChangeBankDetailsLandingPage/index.ts'));

const UpdateBankDetailsForm = React.lazy(() => import(/* webpackChunkName: "UpdateBankDetailsForm" */ '../../jss-components/t27-change-bank-details/UpdateBankDetailsForm/index.ts'));

const SimpleAdviceAccordion = React.lazy(() => import(/* webpackChunkName: "SimpleAdviceAccordion" */ '../../jss-components/t28-simple-advice/SimpleAdviceAccordion/index.ts'));

const SimpleAdviceIgnitionSession = React.lazy(() => import(/* webpackChunkName: "SimpleAdviceIgnitionSession" */ '../../jss-components/t28-simple-advice/SimpleAdviceIgnitionSession/index.ts'));

const SimpleAdviceModal = React.lazy(() => import(/* webpackChunkName: "SimpleAdviceModal" */ '../../jss-components/t28-simple-advice/SimpleAdviceModal/index.ts'));


	const components = new Map();
	components.set('UnauthoredComponent', UnauthoredComponent);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('Dashboard', Dashboard);
components.set('GeneralOneColumn', GeneralOneColumn);
components.set('GeneralTwoColumnLeft', GeneralTwoColumnLeft);
components.set('GeneralTwoColumnRight', GeneralTwoColumnRight);
components.set('UnauthenticatedOneColumn', UnauthenticatedOneColumn);
components.set('Accordion', Accordion);
components.set('CallToActionCard', CallToActionCard);
components.set('ContentBlock', ContentBlock);
components.set('DownloadsBlock', DownloadsBlock);
components.set('HeroModule', HeroModule);
components.set('IconTile', IconTile);
components.set('ImageBlock', ImageBlock);
components.set('LinksBlock', LinksBlock);
components.set('MemberDetailsForm', MemberDetailsForm);
components.set('MemberPreferencesLink', MemberPreferencesLink);
components.set('PageLevelNotification', PageLevelNotification);
components.set('QuickActionsList', QuickActionsList);
components.set('QuickActionsTile', QuickActionsTile);
components.set('RichText', RichText);
components.set('Tabs', Tabs);
components.set('VideoBlock', VideoBlock);
components.set('FiftyFiftySubLayout', FiftyFiftySubLayout);
components.set('FullWidthSubLayout', FullWidthSubLayout);
components.set('OneThirdTwoThirdsSubLayout', OneThirdTwoThirdsSubLayout);
components.set('QuartersSubLayout', QuartersSubLayout);
components.set('ThirdsSubLayout', ThirdsSubLayout);
components.set('TwoThirdsOneThirdSubLayout', TwoThirdsOneThirdSubLayout);
components.set('GreenId', GreenId);
components.set('IDVForm', IDVForm);
components.set('OneTimePasscode', OneTimePasscode);
components.set('VerifyYourIdentity', VerifyYourIdentity);
components.set('DbAccountSnapshot', DbAccountSnapshot);
components.set('DbAccountSnapshotResilience', DbAccountSnapshotResilience);
components.set('DbAnnualStatements', DbAnnualStatements);
components.set('DbBPAY', DbBPAY);
components.set('DbBeneficiaries', DbBeneficiaries);
components.set('DbFinancialAdviserModule', DbFinancialAdviserModule);
components.set('DbHeroBanner', DbHeroBanner);
components.set('DbImportantNotice', DbImportantNotice);
components.set('DbInsuranceCover', DbInsuranceCover);
components.set('DbInsuranceCoverResilience', DbInsuranceCoverResilience);
components.set('DbInvestments', DbInvestments);
components.set('DbInvestmentsResilience', DbInvestmentsResilience);
components.set('DbLatestContributionModule', DbLatestContributionModule);
components.set('DbNextBestActionsModule', DbNextBestActionsModule);
components.set('DbNoiInformationBanner', DbNoiInformationBanner);
components.set('DbOutageModal', DbOutageModal);
components.set('DbPaymentInformation', DbPaymentInformation);
components.set('DbProfileSetupActions', DbProfileSetupActions);
components.set('DbSectionHeading', DbSectionHeading);
components.set('DbSkeletonLoader', DbSkeletonLoader);
components.set('DbVideoBlock', DbVideoBlock);
components.set('Widget', Widget);
components.set('AccountLockedScreen', AccountLockedScreen);
components.set('ContentNotAvailable', ContentNotAvailable);
components.set('DeviceCheck', DeviceCheck);
components.set('DisplayLogoutSuccess', DisplayLogoutSuccess);
components.set('EditUsernameAndPassword', EditUsernameAndPassword);
components.set('GuidedTour', GuidedTour);
components.set('IdentityVerification', IdentityVerification);
components.set('LastLogin', LastLogin);
components.set('LastLoginMobileView', LastLoginMobileView);
components.set('Login', Login);
components.set('LoginSettings', LoginSettings);
components.set('MPRegistrationForm', MPRegistrationForm);
components.set('ManageTrustedDevice', ManageTrustedDevice);
components.set('OnboardingJourney', OnboardingJourney);
components.set('OutageBannerNotification', OutageBannerNotification);
components.set('RecoverUsername', RecoverUsername);
components.set('ResetPassword', ResetPassword);
components.set('ResilienceMaintenance', ResilienceMaintenance);
components.set('SecurityTip', SecurityTip);
components.set('WelcomeBanner', WelcomeBanner);
components.set('WelcomeDashboardModule', WelcomeDashboardModule);
components.set('PendingProfileAccountDetailsModule', PendingProfileAccountDetailsModule);
components.set('PendingProfileActionsModule', PendingProfileActionsModule);
components.set('AccountSwitcher', AccountSwitcher);
components.set('MemberContactDetails', MemberContactDetails);
components.set('RestrictionNotification', RestrictionNotification);
components.set('AnnualStatements', AnnualStatements);
components.set('SavedApplications', SavedApplications);
components.set('SubmittedApplications', SubmittedApplications);
components.set('SubmittedBankAccount', SubmittedBankAccount);
components.set('SubmittedDirectDebit', SubmittedDirectDebit);
components.set('SubmittedFinancialHardship', SubmittedFinancialHardship);
components.set('SubmittedNoticeOfIntent', SubmittedNoticeOfIntent);
components.set('SubmittedReachedPreservationAge', SubmittedReachedPreservationAge);
components.set('SubmittedSpouseContribution', SubmittedSpouseContribution);
components.set('SubmittedTransferToAnotherFund', SubmittedTransferToAnotherFund);
components.set('SubmittedUnrestrictedNonPreserved', SubmittedUnrestrictedNonPreserved);
components.set('ViewApplicationDetails', ViewApplicationDetails);
components.set('AccountsDetailsModule', AccountsDetailsModule);
components.set('NotifyYourEmployer', NotifyYourEmployer);
components.set('NotifyYourEmployerConfirmation', NotifyYourEmployerConfirmation);
components.set('TransactionsSummary', TransactionsSummary);
components.set('ViewBalanceHistory', ViewBalanceHistory);
components.set('ViewTransactions', ViewTransactions);
components.set('BPAY', BPAY);
components.set('BPAYDownsizer', BPAYDownsizer);
components.set('ContributionCaps', ContributionCaps);
components.set('DirectDebit', DirectDebit);
components.set('DirectDebitForm', DirectDebitForm);
components.set('SpouseContributionsConfirmation', SpouseContributionsConfirmation);
components.set('SpouseContributionsForm', SpouseContributionsForm);
components.set('SpouseContributionsLandingPage', SpouseContributionsLandingPage);
components.set('TotalContributions', TotalContributions);
components.set('ManageBeneficiaries', ManageBeneficiaries);
components.set('ViewUpdateBeneficiaries', ViewUpdateBeneficiaries);
components.set('CardList', CardList);
components.set('CombineSuperContext', CombineSuperContext);
components.set('CombineSuperForm', CombineSuperForm);
components.set('SimpleConsolidationForm', SimpleConsolidationForm);
components.set('BenefitQuoteResults', BenefitQuoteResults);
components.set('GenerateBenefitQuote', GenerateBenefitQuote);
components.set('EditInvestmentOptions', EditInvestmentOptions);
components.set('ViewInvestmentPerformance', ViewInvestmentPerformance);
components.set('ViewInvestments', ViewInvestments);
components.set('ViewPendingInvestmentSwitch', ViewPendingInvestmentSwitch);
components.set('CentrelinkDownloadSection', CentrelinkDownloadSection);
components.set('EditPaymentAmountAndFrequency', EditPaymentAmountAndFrequency);
components.set('ViewBankDetails', ViewBankDetails);
components.set('ViewCentrelinkSchedule', ViewCentrelinkSchedule);
components.set('ViewPaymentDetails', ViewPaymentDetails);
components.set('ViewPaymentSummary', ViewPaymentSummary);
components.set('FinancialHardshipA', FinancialHardshipA);
components.set('FinancialHardshipB', FinancialHardshipB);
components.set('Pension', Pension);
components.set('ReachedPreservationAge', ReachedPreservationAge);
components.set('TransferToAnotherFund', TransferToAnotherFund);
components.set('UnrestrictedNonPreserved', UnrestrictedNonPreserved);
components.set('WithdrawalsDownloadsBlock', WithdrawalsDownloadsBlock);
components.set('WithdrawalsLandingPage', WithdrawalsLandingPage);
components.set('LoadingScreen', LoadingScreen);
components.set('MobileRestrictionScreen', MobileRestrictionScreen);
components.set('RenderButtons', RenderButtons);
components.set('SaveScreen', SaveScreen);
components.set('WithdrawalsErrorModal', WithdrawalsErrorModal);
components.set('TALRefresh', TALRefresh);
components.set('ViewInsuranceCover', ViewInsuranceCover);
components.set('ViewInsuranceCoverSummary', ViewInsuranceCoverSummary);
components.set('CommunicationPreferences', CommunicationPreferences);
components.set('InboxMessagesAndNotifications', InboxMessagesAndNotifications);
components.set('TaxFileNumber', TaxFileNumber);
components.set('LivePerson', LivePerson);
components.set('NoticeOfIntentForm', NoticeOfIntentForm);
components.set('NoticeOfIntentLandingPage', NoticeOfIntentLandingPage);
components.set('ChangeBankDetailsForm', ChangeBankDetailsForm);
components.set('ChangeBankDetailsLandingPage', ChangeBankDetailsLandingPage);
components.set('UpdateBankDetailsForm', UpdateBankDetailsForm);
components.set('SimpleAdviceAccordion', SimpleAdviceAccordion);
components.set('SimpleAdviceIgnitionSession', SimpleAdviceIgnitionSession);
components.set('SimpleAdviceModal', SimpleAdviceModal);

	const Fallback = () => <div />;

	function withSuspense(Component) {
		return function SuspendedComponent(props) {
			return (
				<Suspense fallback={<Fallback />}>
					<Component {...props} />
				</Suspense>
			);
		};
	}

	export default function componentFactory(componentName) {
		const Component = components.get(componentName);
		if (!Component) {
			// eslint-disable-next-line no-console
			console.warn('[Sitecore JSS] Component not found in factory: ' + componentName + '.');
			return Fallback;
		}
		return withSuspense(Component);
	}
	